require.context("assets/", false, /^\.\/.*\.*$/);

require("src/styles/main.scss");
require("src/styles/static.css");

require("languages/en_EN.json");

require("angular");
var deferredBootstrapper = require("angular-deferred-bootstrap");

require("angular-animate");
require("angular-route");
require("angular-translate");
require("angular-translate-loader-static-files");
require("angular-cookies");
require("angular-bootstrap");
// require("angular-facebook");
require("angular-stripe");
require("angular-socialshare");
require("angular-ui-notification");
require("ng-twitter-api");
require("angular-moment");
require("ngAutocomplete");
require("ngAutocomplete");
require("ng-tags-input");

require("angular-spinners");//loading spinner
require("./modules/sprintf");//the original is crappy

require("at-table");
require("restangular");
require("ng-file-upload");

require("angular-sanitize");
require("ngWYSIWYG");
require("ngInfiniteScroll");

var $ = require("jquery");
var main = require("src/scripts/main");

var config = require("src/scripts/config");
var jsonConfigDev = require("!json!config-development.json");
var jsonConfigStaging = require("!json!config-staging.json");
var jsonConfigProduction = require("!json!config-production.json");


if (__DEV__) {
	config.Config.load(jsonConfigDev);
} else if (__STAGING__) {
	config.Config.load(jsonConfigStaging);
} else if (__PRODUCTION__) {
	config.Config.load(jsonConfigProduction);
} else {
	throw "NO CONFIG LOADED";
}



$(function() {
	$("head").append("<meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'>");
	$("body").attr("translate-cloak", "");
	$("body").append("\
		<div class='ot-site-content'>\
			<spinner name='mainSpinner' show='false'>\
			<div class='ot-spinner-overlay'></div>\
			<div class='spinner'>\
				<div class='double-bounce1'></div>\
				<div class='double-bounce2'></div>\
			</div>\
			</spinner>\
			<ot-header></ot-header>\
			<div ng-view></div>\
		</div>\
	");
	new main.Main().init(deferredBootstrapper);
	//window.onbeforeunload = function () {
	//    return "Do you really want to close?";
	//};
});


//Moved facebook init here to use the right facebook app

window.fbAsyncInit = function() {
	FB.init({
		appId      : config.Config.facebookAppId,
		xfbml      : true,
		status     : true,
		cookie     : true,
		version    : 'v2.5'
	});
};

(function(d, s, id){
	 var js, fjs = d.getElementsByTagName(s)[0];
	 if (d.getElementById(id)) {return;}
	 js = d.createElement(s); js.id = id;
	 js.src = "//connect.facebook.net/en_US/sdk.js";
	 fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));



/*****************
 ** WEBPACK FOOTER
 ** ./src/scripts/boot.js
 ** module id = 0
 ** module chunks = 1
 **/